const STORAGE_NAMESPACE = "geneilytics";
const SCOPED_STORAGE_PREFIX = `${STORAGE_NAMESPACE}:scope:`;
const CURRENT_SCOPE_KEY = `${STORAGE_NAMESPACE}:current_scope`;

const LEGACY_UNSAFE_KEYS = [
  "smtpConfig",
  "user",
  "user_name",
  "user_role",
  "platform_role",
  "user_avatar",
  "user_can_download",
  "tables",
  "selected_tables",
  "db_config",
  "selected_database_id",
  "session_id",
  "sessions",
];

export const SCOPED_WORKSPACE_KEYS = [
  "selected_database_id",
  "session_id",
  "sessions",
  "sidebar_mode",
  "voice_lang",
];

export const getStorageScope = (profile) => {
  const payload = profile || {};
  const runtime = payload.runtime || {};
  const user = payload.user || {};

  if (!user?.id) {
    return null;
  }

  if (runtime.actor_type === "platform_user") {
    return `platform:${user.id}`;
  }

  if (runtime.actor_type === "tenant_user" && runtime.tenant_id !== null && runtime.tenant_id !== undefined) {
    return `tenant:${runtime.tenant_id}:user:${user.id}`;
  }

  return null;
};

const getScopedKey = (scope, key) => `${SCOPED_STORAGE_PREFIX}${scope}:${key}`;

export const readScopedValue = (scope, key) => {
  if (!scope || !key) return null;
  return localStorage.getItem(getScopedKey(scope, key));
};

export const writeScopedValue = (scope, key, value) => {
  if (!scope || !key) return;

  if (value === null || value === undefined || value === "") {
    localStorage.removeItem(getScopedKey(scope, key));
    return;
  }

  localStorage.setItem(getScopedKey(scope, key), String(value));
};

export const removeScopedValue = (scope, key) => {
  if (!scope || !key) return;
  localStorage.removeItem(getScopedKey(scope, key));
};

export const setCurrentStorageScope = (scope) => {
  if (!scope) {
    sessionStorage.removeItem(CURRENT_SCOPE_KEY);
    return;
  }

  sessionStorage.setItem(CURRENT_SCOPE_KEY, scope);
};

export const getCurrentStorageScope = () => sessionStorage.getItem(CURRENT_SCOPE_KEY);

export const clearCurrentStorageScope = () => {
  sessionStorage.removeItem(CURRENT_SCOPE_KEY);
};

export const clearScopedWorkspaceStorage = (scope) => {
  if (!scope) return;
  SCOPED_WORKSPACE_KEYS.forEach((key) => removeScopedValue(scope, key));
};

export const clearCurrentScopedWorkspaceStorage = () => {
  const scope = getCurrentStorageScope();
  clearScopedWorkspaceStorage(scope);
  clearCurrentStorageScope();
};

export const clearAllScopedStorage = () => {
  const keysToRemove = [];

  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (key?.startsWith(SCOPED_STORAGE_PREFIX)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
  clearCurrentStorageScope();
};

export const clearLegacyUnsafeStorage = () => {
  LEGACY_UNSAFE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const clearAuthTokens = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
};

export const resetAppStorageForLogout = () => {
  clearAuthTokens();
  clearLegacyUnsafeStorage();
  clearCurrentScopedWorkspaceStorage();
};

export const resetAppStorageForLogin = () => {
  clearAuthTokens();
  clearLegacyUnsafeStorage();
  clearCurrentScopedWorkspaceStorage();
};
